/**
 * @generated SignedSource<<aaf379982b6c7f5f37caeb38b22270c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row_issue$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"RowInner_old" | "RowMaybeWithDragAndDrop_issueOld" | "RowWithDragAndDrop_issueOld" | "RowWithSiblingCreate_issueOld">;
  readonly " $fragmentType": "Row_issue";
};
export type Row_issue$key = {
  readonly " $data"?: Row_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row_issue">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isDensityFull",
    "variableName": "isDensityFull"
  },
  {
    "kind": "Variable",
    "name": "isLinkRelationshipFieldEnabled",
    "variableName": "isLinkRelationshipFieldEnabled"
  },
  {
    "kind": "Variable",
    "name": "isRemoteLinkedIssuesEnabled",
    "variableName": "isRemoteLinkedIssuesEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "Row_issue",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RowInner_old"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RowWithSiblingCreate_issueOld"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RowMaybeWithDragAndDrop_issueOld"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RowWithDragAndDrop_issueOld"
    }
  ],
  "type": "JiraIssue"
};
})();

(node as any).hash = "968b198f6e6f30043408bdba8e3d0408";

export default node;
